export const PATIENT_GET_REQUEST = 'PATIENT_GET_REQUEST';
export const PATIENT_GET_SUCCESS = 'PATIENT_GET_SUCCESS';
export const PATIENT_GET_ERROR = 'PATIENT_GET_ERROR';
export const PATIENT_GET_BY_KEY_REQUEST = 'PATIENT_GET_BY_KEY_REQUEST';
export const PATIENT_GET_BY_KEY_SUCCESS = 'PATIENT_GET_BY_KEY_SUCCESS';
export const PATIENT_GET_BY_KEY_ERROR = 'PATIENT_GET_BY_KEY_ERROR';
export const PATIENT_ADD_REQUEST = 'PATIENT_ADD_REQUEST';
export const PATIENT_ADD_SUCCESS = 'PATIENT_ADD_SUCCESS';
export const PATIENT_ADD_ERROR = 'PATIENT_ADD_ERROR';
export const PATIENT_EDIT_REQUEST = 'PATIENT_EDIT_REQUEST';
export const PATIENT_EDIT_SUCCESS = 'PATIENT_EDIT_SUCCESS';
export const PATIENT_EDIT_ERROR = 'PATIENT_EDIT_ERROR';
export const PATIENT_DELETE_REQUEST = 'PATIENT_DELETE_REQUEST';
export const PATIENT_DELETE_SUCCESS = 'PATIENT_DELETE_SUCCESS';
export const PATIENT_DELETE_ERROR = 'PATIENT_DELETE_ERROR';
